<template>
  <div>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <!-- <img src="static/img/avatars/6.jpg" class="img-avatar" alt="cec@cecweb.com"> -->
          <img :src="'data:image/jpeg;base64,'+foto" class="img-avatar" alt="adm@hayhudev.com.br">
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Conta</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-user"></i> Perfil</b-dropdown-item>
        <!--
        <b-dropdown-item><i class="fa fa-bell-o"></i> Alertas<b-badge variant="info">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-envelope-o"></i> Messages<b-badge variant="success">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-tasks"></i> Tarefas<b-badge variant="danger">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-comments"></i> Comments<b-badge variant="warning">{{itemsCount}}</b-badge></b-dropdown-item>
        -->
        <b-dropdown-header tag="div" class="text-center" v-if="permissoes.acessoUsuario || permissoes.acessoGrupoAcesso || hasAnyConfiguracaoPermissao"><strong>Segurança</strong></b-dropdown-header>
        <b-dropdown-item v-if="permissoes.acessoUsuario" @click.stop.prevent="irParaUsuarios()">
          <i class="fa fa-users"></i> Usuários
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoes.acessoGrupoAcesso" @click.stop.prevent="irParaGruposAcesso()">
          <i class="fa fa-unlock-alt"></i> Grupos de Acesso
        </b-dropdown-item>
        <b-dropdown-item @click.stop.prevent="alterarSenha()"><i class="fa fa-key"></i> Senha</b-dropdown-item>
        <!--
        <b-dropdown-item><i class="fa fa-usd"></i> Payments<b-badge variant="secondary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-file"></i> Projects<b-badge variant="primary">{{itemsCount}}</b-badge></b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        -->
        <b-dropdown-item><i class="fa fa-shield"></i> Bloquear</b-dropdown-item>
        <b-dropdown-item @click.stop.prevent="logout()"><i class="fa fa-lock"></i> Sair</b-dropdown-item>

        <b-dropdown-header tag="div" class="text-center"><strong>Configurações</strong></b-dropdown-header>
        <!-- Submenu de Configurações do Sistema -->
        <b-dropdown-item v-if="permissoesConfiguracao.movimentacao" @click.stop.prevent="irParaConfiguracao('movimentacao')">
          <i class="fa fa-exchange"></i> Movimentação
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.compravenda" @click.stop.prevent="irParaConfiguracao('compravenda')">
          <i class="fa fa-shopping-cart"></i> Compra e Venda
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.estoque" @click.stop.prevent="irParaConfiguracao('estoque')">
          <i class="fa fa-cube"></i> Estoque
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.desossa" @click.stop.prevent="irParaConfiguracao('desossa')">
          <i class="fa fa-cut"></i> Desossa
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.abate" @click.stop.prevent="irParaConfiguracao('abate')">
          <i class="fa fa-industry"></i> Abate
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.notafiscal" @click.stop.prevent="irParaConfiguracao('notafiscal')">
          <i class="fa fa-file-text"></i> Nota Fiscal
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.textonotafiscal" @click.stop.prevent="irParaConfiguracao('textonotafiscal')">
          <i class="fa fa-align-left"></i> Textos Nota Fiscal
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.compras" @click.stop.prevent="irParaConfiguracao('compras')">
          <i class="fa fa-shopping-basket"></i> Pedido de Compras
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.boleto" @click.stop.prevent="irParaConfiguracao('boleto')">
          <i class="fa fa-barcode"></i> Boleto Bancário
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.empresa" @click.stop.prevent="irParaConfiguracao('empresa')">
          <i class="fa fa-building"></i> Empresa
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.balanca" @click.stop.prevent="irParaConfiguracao('balanca')">
          <i class="fa fa-balance-scale"></i> Balança
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.etiqueta" @click.stop.prevent="irParaConfiguracao('etiqueta')">
          <i class="fa fa-tag"></i> Etiqueta
        </b-dropdown-item>
        <b-dropdown-item v-if="permissoesConfiguracao.acessorios" @click.stop.prevent="irParaConfiguracao('acessorios')">
          <i class="fa fa-wrench"></i> Acessórios
        </b-dropdown-item>
        
        
      </b-nav-item-dropdown>

      <!-- Modais de Configuração -->
      <modal-configuracao-movimentacao ref="modalMovimentacao" />
      <modal-configuracao-compra-venda ref="modalCompraVenda" />
      <modal-configuracao-estoque ref="modalEstoque" />
      <modal-configuracao-desossa-abate ref="modalDesossaAbate" />
      <modal-configuracao-nota-fiscal ref="modalNotaFiscal" />
      <modal-configuracao-etiqueta ref="modalEtiqueta" />
      <modal-configuracao-empresa ref="modalEmpresa" />
  </div>
</template>
<script>
import ModalConfiguracaoMovimentacao from '../../modals/ModalConfiguracaoMovimentacao.vue'
import ModalConfiguracaoCompraVenda from '../../modals/ModalConfiguracaoCompraVenda.vue'
import ModalConfiguracaoEstoque from '../../modals/ModalConfiguracaoEstoque.vue'
import ModalConfiguracaoDesossaAbate from '../../modals/ModalConfiguracaoDesossaAbate.vue'
import ModalConfiguracaoNotaFiscal from '../../modals/ModalConfiguracaoNotaFiscal.vue'
import ModalConfiguracaoEtiqueta from '../../modals/ModalConfiguracaoEtiqueta.vue'
    import ModalConfiguracaoEmpresa from '../../modals/ModalConfiguracaoEmpresa.vue'

  export default {
    name: 'header-dropdown',
    components: {
      ModalConfiguracaoMovimentacao,
      ModalConfiguracaoCompraVenda,
      ModalConfiguracaoEstoque,
      ModalConfiguracaoDesossaAbate,
      ModalConfiguracaoNotaFiscal,
      ModalConfiguracaoEtiqueta,
      ModalConfiguracaoEmpresa
    },
    data: () => {
      return { 
        itemsCount: 0,
        permissoes: {
          acessoUsuario: false,
          acessoGrupoAcesso: false
        },
        permissoesConfiguracao: {
          movimentacao: false,
          compravenda: false,
          estoque: false,
          desossa: false,
          abate: false,
          notafiscal: false,
          textonotafiscal: false,
          compras: false,
          boleto: false,
          empresa: false,
          balanca: false,
          etiqueta: false,
          acessorios: false
        }
      }
    },
    async created() {
      await this.carregarPermissoes()
      await this.carregarPermissoesConfiguracao()
    },
    computed: {
      foto () {
        return window.localStorage.getItem('foto')
      },
      nomeusuario () {
        return window.localStorage.getItem('nomeusuario')
      },
      hasAnyConfiguracaoPermissao() {
        return Object.values(this.permissoesConfiguracao).some(p => p === true)
      }
    },
    methods: {
      async carregarPermissoes() {
        try {
          const login = window.localStorage.getItem('login')
          if (!login) return
          
          const { data } = await this.$http.get('/api/protected/menu/verificarPermissoesAdmin', {
            params: { usuarioid: login }
          })
          
          this.permissoes = data
        } catch (err) {
          console.error('Erro ao carregar permissões administrativas:', err)
          this.permissoes = {
            acessoUsuario: false,
            acessoGrupoAcesso: false
          }
        }
      },
      async carregarPermissoesConfiguracao() {
        try {
          const login = window.localStorage.getItem('login')
          if (!login) return
          
          const { data } = await this.$http.get('/api/protected/menu/verificarPermissoesConfiguracao', {
            params: { usuarioid: login }
          })
          
          this.permissoesConfiguracao = data
        } catch (err) {
          console.error('Erro ao carregar permissões de configuração:', err)
          this.permissoesConfiguracao = {
            movimentacao: false,
            compravenda: false,
            estoque: false,
            desossa: false,
            abate: false,
            notafiscal: false,
            textonotafiscal: false,
            compras: false,
            boleto: false,
            empresa: false,
            balanca: false,
            etiqueta: false,
            acessorios: false
          }
        }
      },
      async logout () {
        try {
          await this.$http.post('/api/protected/logout')
          window.localStorage.clear()
          this.$router.replace('/pages/login')
        } catch(err) {
          this.$root.$bvToast.toast(`Crendenciais ativas!!`, {
            title: 'Logout',
            autoHideDelay: 100,
            variant: 'warning',
            appendToast: true
          })
          window.localStorage.clear()
          this.$router.push('/pages/login')
        } 
        
      },
      alterarSenha(){
        this.$router.push('/pages/senha')
      },
      irParaUsuarios() {
        this.$router.push('/seguranca/usuario/index')
      },
      irParaGruposAcesso() {
        this.$router.push('/seguranca/grupoacesso/index')
      },
      irParaConfiguracao(tipo) {
        // Abrir modal correspondente diretamente
        switch(tipo) {
          case 'movimentacao':
            this.$refs.modalMovimentacao.abrir()
            break
          case 'compravenda':
            this.$refs.modalCompraVenda.abrir()
            break
          case 'estoque':
            this.$refs.modalEstoque.abrir()
            break
          case 'desossa':
            this.$refs.modalDesossaAbate.abrir()
            break
          case 'abate':
            this.$refs.modalDesossaAbate.abrir()
            break
          case 'notafiscal':
            this.$refs.modalNotaFiscal.abrir()
            break
          case 'etiqueta':
            this.$refs.modalEtiqueta.abrir()
            break
          case 'textonotafiscal':
            // TODO: Implementar modal de textos nota fiscal
            this.$root.$bvToast.toast('Modal ainda não implementado', {
              title: 'Em desenvolvimento',
              variant: 'info'
            })
            break
          case 'compras':
            // TODO: Implementar modal de pedido de compras
            this.$root.$bvToast.toast('Modal ainda não implementado', {
              title: 'Em desenvolvimento',
              variant: 'info'
            })
            break
          case 'boleto':
            // TODO: Implementar modal de boleto bancário
            this.$root.$bvToast.toast('Modal ainda não implementado', {
              title: 'Em desenvolvimento',
              variant: 'info'
            })
            break
          case 'empresa':
            this.$refs.modalEmpresa.abrir()
            break
          case 'balanca':
            // TODO: Implementar modal de balança
            this.$root.$bvToast.toast('Modal ainda não implementado', {
              title: 'Em desenvolvimento',
              variant: 'info'
            })
            break
          case 'acessorios':
            // TODO: Implementar modal de acessórios
            this.$root.$bvToast.toast('Modal ainda não implementado', {
              title: 'Em desenvolvimento',
              variant: 'info'
            })
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue